const translations = {
  fr: {
    // General
    appName: "DreamNoor",
    welcome: "Bienvenue sur",
    salam: "Salam,",
    explore: "Explorez vos rêves, comprenez vos signes",
    explorer: "Explorer",
    loading: "Chargement...",
    error: "Erreur",
    retry: "Réessayer",
    back: "Retour",
    send: "Envoyer",
    save: "Enregistrer",
    delete: "Supprimer",
    cancel: "Annuler",
    close: "Fermer",
    optional: "optionnel",

    // Nav
    navHome: "Accueil",
    navDreams: "Rêves",
    navSigns: "Signes",
    navWellness: "Détente",
    navProfile: "Profil",
    navJournal: "Journal",

    // Home
    inspirationTitle: "Inspiration du jour",
    dreamsRecorded: "Rêves enregistrés",
    today: "Aujourd'hui",
    interpretDream: "Interpréter un rêve",
    signs: "Signes",
    wellness: "Détente",
    journal: "Journal",
    createAccount: "Créer un compte",
    createAccountSub: "Sauvegardez vos rêves et analyses",
    analyzeDreams: "Analyse de mes rêves",
    analyzeDreamsSub: "Patterns, émotions, tendances",

    // Auth
    login: "Connexion",
    register: "Inscription",
    name: "Nom",
    email: "Email",
    password: "Mot de passe",
    yourName: "Votre nom",
    yourEmail: "votre@email.com",
    passwordPlaceholder: "Mot de passe",
    loginBtn: "Se connecter",
    registerBtn: "Créer un compte",
    continueWithout: "Continuer sans compte",
    saveYourDreams: "Sauvegardez vos rêves et analyses",
    emailUsed: "Cet email est déjà utilisé",
    wrongCredentials: "Email ou mot de passe incorrect",
    genericError: "Une erreur est survenue",

    // Interpret
    interpretTitle: "Interpréter un rêve",
    interpretSub: "L'IA analyse votre rêve avec sagesse spirituelle",
    personalizeTitle: "Personnalisez votre interprétation",
    situationLabel: "Votre situation & ressenti",
    situationPlaceholder: "Je suis un homme de 30 ans, marié, un peu stressé en ce moment à cause du travail...",
    describeYourDream: "Votre rêve",
    dreamPlaceholder: "J'ai rêvé que je marchais dans un jardin lumineux, entouré de fleurs blanches...",
    interpretBtn: "Interpréter mon rêve",
    interpreting: "Interprétation en cours...",
    interpretation: "Interprétation",
    interpretError: "Erreur lors de l'interprétation. Réessayez.",
    dailyLimitTitle: "Limite atteinte",
    dailyLimitText: "Vous avez utilisé vos 3 interprétations gratuites du jour.",
    dailyLimitCta: "Passez Premium pour des interprétations illimitées",
    remainingToday: "interprétation(s) restante(s) aujourd'hui",

    // Onboarding
    gender: "Sexe",
    male: "Homme",
    female: "Femme",
    age: "Âge",
    yourAge: "Votre âge",
    familyStatus: "Situation familiale",
    single: "Célibataire",
    married: "Marié(e)",
    divorced: "Divorcé(e)",
    widowed: "Veuf(ve)",
    childrenCount: "Nombre d'enfants",
    howFeeling: "Comment vous sentez-vous?",
    stressed: "Stressé(e)",
    calm: "Calme",
    tired: "Fatigué(e)",
    happy: "Heureux(se)",
    anxious: "Anxieux(se)",
    sad: "Triste",
    atPeace: "En paix",
    confused: "Confus(e)",
    motivated: "Motivé(e)",

    // Signs
    signsTitle: "Comprendre les signes",
    signsSub: "Décryptez les messages de votre quotidien",
    describeSign: "Décrivez le signe observé",
    signPlaceholder: "J'ai vu un oiseau blanc se poser devant ma fenêtre trois matins de suite...",
    interpretSign: "Interpréter ce signe",
    analyzing: "Analyse en cours...",
    meaning: "Signification",

    // Journal
    dreamJournal: "Journal des rêves",
    dreamCount: "{count} rêve(s) enregistré(s)",
    newDream: "Nouveau rêve",
    dreamTitle: "Titre du rêve",
    describeDream: "Décrivez votre rêve en détail...",
    emotions: "Émotions",
    themes: "Thèmes",
    saveDream: "Enregistrer le rêve",
    saving: "Sauvegarde...",
    noDreams: "Aucun rêve enregistré",
    noDreamsSub: "Commencez par ajouter votre premier rêve",
    deleteDream: "Supprimer ce rêve ?",
    interpretThis: "Interpréter ce rêve",

    // Emotions & Tags
    joy: "Joie", fear: "Peur", surprise: "Surprise", sadness: "Tristesse",
    confusion: "Confusion", peace: "Paix", hope: "Espoir", anxiety: "Anxiété",
    water: "Eau", sky: "Ciel", animal: "Animal", person: "Personne",
    light: "Lumière", darkness: "Obscurité", flight: "Vol", travel: "Voyage",
    house: "Maison", nature: "Nature", prayer: "Prière", death: "Mort",

    // Wellness
    wellnessTitle: "Détente & Sons",
    wellnessSub: "Créez votre ambiance apaisante",
    activeSound: "son actif",
    activeSounds: "sons actifs",
    remaining: "restant",
    timer: "Timer",
    stopAll: "Tout arrêter",
    autoStop: "Arrêt automatique après",
    sea: "Vagues de l'océan",
    seagulls: "Pluie & Oiseaux",
    birds: "Oiseaux",
    wind: "Vent",
    rain: "Pluie",
    storm: "Orage",
    river: "Rivière",
    forest: "Forêt",
    fireplace: "Feu de cheminée",
    nightCalm: "Nuit calme",
    mosque: "Ambiance calme",

    // Analysis
    analysisTitle: "Analyse des rêves",
    analysisSub: "Patterns, émotions et tendances",
    dreamsAnalyzed: "Rêves analysés",
    recurringEmotions: "Émotions récurrentes",
    dominantThemes: "Thèmes dominants",
    monthlyActivity: "Activité mensuelle",
    startRecording: "Commencez par enregistrer des rêves pour voir vos analyses",

    // Profile
    myProfile: "Mon profil",
    darkMode: "Mode sombre",
    lightMode: "Mode clair",
    premiumTitle: "DreamNoor Premium",
    premiumMember: "Vous êtes membre Premium",
    premiumDesc: "Accédez à toutes les fonctionnalités sans publicité.",
    monthly: "Mensuel",
    yearly: "Annuel",
    perMonth: "/mois",
    perYear: "/an",
    unlimitedInterpretations: "Interprétations illimitées",
    noAds: "Sans publicité",
    fullAccess: "Accès complet aux fonctionnalités",
    subscribe: "S'abonner",
    comingSoon: "Bientôt disponible",
    about: "À propos",
    aboutText: "DreamNoor combine la sagesse islamique traditionnelle et l'intelligence artificielle pour vous aider à explorer vos rêves.",
    logout: "Se déconnecter",
    language: "Langue",

    // Reviews
    userReviews: "Avis des utilisateurs",
    reviews: "avis",
    writeReview: "Donner un avis",
    yourReviewMatters: "Votre avis compte",
    shareExperience: "Partagez votre expérience avec DreamNoor...",
    publishReview: "Publier mon avis",
    sending: "Envoi...",
    noReviews: "Aucun avis pour le moment",
    beFirst: "Soyez le premier à partager votre expérience",

    // Subscription success
    checkingPayment: "Vérification du paiement...",
    pleaseWait: "Un instant, nous vérifions votre paiement",
    welcomePremium: "Bienvenue Premium !",
    premiumSuccess: "Vous avez maintenant accès à toutes les fonctionnalités DreamNoor sans publicité.",
    backToApp: "Retour à l'application",
    sessionExpired: "Session expirée",
    paymentError: "Erreur de paiement",
    paymentFailed: "Le paiement n'a pas pu être confirmé. Veuillez réessayer.",
    redirecting: "Redirection...",
    checking: "Vérification...",
  },

  en: {
    appName: "DreamNoor",
    welcome: "Welcome to",
    salam: "Salam,",
    explore: "Explore your dreams, understand your signs",
    explorer: "Explore",
    loading: "Loading...",
    error: "Error",
    retry: "Retry",
    back: "Back",
    send: "Send",
    save: "Save",
    delete: "Delete",
    cancel: "Cancel",
    close: "Close",
    optional: "optional",

    navHome: "Home",
    navDreams: "Dreams",
    navSigns: "Signs",
    navWellness: "Relax",
    navProfile: "Profile",
    navJournal: "Journal",

    inspirationTitle: "Inspiration of the day",
    dreamsRecorded: "Dreams recorded",
    today: "Today",
    interpretDream: "Interpret a dream",
    signs: "Signs",
    wellness: "Relax",
    journal: "Journal",
    createAccount: "Create an account",
    createAccountSub: "Save your dreams and analyses",
    analyzeDreams: "Analyze my dreams",
    analyzeDreamsSub: "Patterns, emotions, trends",

    login: "Login",
    register: "Sign up",
    name: "Name",
    email: "Email",
    password: "Password",
    yourName: "Your name",
    yourEmail: "your@email.com",
    passwordPlaceholder: "Password",
    loginBtn: "Log in",
    registerBtn: "Create account",
    continueWithout: "Continue without account",
    saveYourDreams: "Save your dreams and analyses",
    emailUsed: "This email is already in use",
    wrongCredentials: "Incorrect email or password",
    genericError: "An error occurred",

    interpretTitle: "Interpret a dream",
    interpretSub: "AI analyzes your dream with spiritual wisdom",
    personalizeTitle: "Personalize your interpretation",
    situationLabel: "Your situation & feelings",
    situationPlaceholder: "I am a 30-year-old married man, a bit stressed at work lately...",
    describeYourDream: "Your dream",
    dreamPlaceholder: "I dreamed that I was walking in a luminous garden, surrounded by white flowers...",
    interpretBtn: "Interpret my dream",
    interpreting: "Interpreting...",
    interpretation: "Interpretation",
    interpretError: "Error during interpretation. Please try again.",
    dailyLimitTitle: "Limit reached",
    dailyLimitText: "You have used your 3 free interpretations for today.",
    dailyLimitCta: "Go Premium for unlimited interpretations",
    remainingToday: "interpretation(s) remaining today",

    gender: "Gender",
    male: "Male",
    female: "Female",
    age: "Age",
    yourAge: "Your age",
    familyStatus: "Family status",
    single: "Single",
    married: "Married",
    divorced: "Divorced",
    widowed: "Widowed",
    childrenCount: "Number of children",
    howFeeling: "How are you feeling?",
    stressed: "Stressed",
    calm: "Calm",
    tired: "Tired",
    happy: "Happy",
    anxious: "Anxious",
    sad: "Sad",
    atPeace: "At peace",
    confused: "Confused",
    motivated: "Motivated",

    signsTitle: "Understand the signs",
    signsSub: "Decode the messages of your daily life",
    describeSign: "Describe the sign you observed",
    signPlaceholder: "I saw a white bird landing on my window three mornings in a row...",
    interpretSign: "Interpret this sign",
    analyzing: "Analyzing...",
    meaning: "Meaning",

    dreamJournal: "Dream Journal",
    dreamCount: "{count} dream(s) recorded",
    newDream: "New dream",
    dreamTitle: "Dream title",
    describeDream: "Describe your dream in detail...",
    emotions: "Emotions",
    themes: "Themes",
    saveDream: "Save dream",
    saving: "Saving...",
    noDreams: "No dreams recorded",
    noDreamsSub: "Start by adding your first dream",
    deleteDream: "Delete this dream?",
    interpretThis: "Interpret this dream",

    joy: "Joy", fear: "Fear", surprise: "Surprise", sadness: "Sadness",
    confusion: "Confusion", peace: "Peace", hope: "Hope", anxiety: "Anxiety",
    water: "Water", sky: "Sky", animal: "Animal", person: "Person",
    light: "Light", darkness: "Darkness", flight: "Flight", travel: "Travel",
    house: "House", nature: "Nature", prayer: "Prayer", death: "Death",

    wellnessTitle: "Relax & Sounds",
    wellnessSub: "Create your soothing ambiance",
    activeSound: "active sound",
    activeSounds: "active sounds",
    remaining: "remaining",
    timer: "Timer",
    stopAll: "Stop all",
    autoStop: "Auto stop after",
    sea: "Ocean Waves",
    seagulls: "Rain & Birds",
    birds: "Birds",
    wind: "Wind",
    rain: "Rain",
    storm: "Storm",
    river: "River",
    forest: "Forest",
    fireplace: "Fireplace",
    nightCalm: "Calm night",
    mosque: "Calm ambiance",

    analysisTitle: "Dream Analysis",
    analysisSub: "Patterns, emotions and trends",
    dreamsAnalyzed: "Dreams analyzed",
    recurringEmotions: "Recurring emotions",
    dominantThemes: "Dominant themes",
    monthlyActivity: "Monthly activity",
    startRecording: "Start recording dreams to see your analyses",

    myProfile: "My Profile",
    darkMode: "Dark mode",
    lightMode: "Light mode",
    premiumTitle: "DreamNoor Premium",
    premiumMember: "You are a Premium member",
    premiumDesc: "Access all features without ads.",
    monthly: "Monthly",
    yearly: "Yearly",
    perMonth: "/month",
    perYear: "/year",
    unlimitedInterpretations: "Unlimited interpretations",
    noAds: "No ads",
    fullAccess: "Full access to all features",
    subscribe: "Subscribe",
    comingSoon: "Coming soon",
    about: "About",
    aboutText: "DreamNoor combines traditional Islamic wisdom and artificial intelligence to help you explore your dreams.",
    logout: "Log out",
    language: "Language",

    userReviews: "User reviews",
    reviews: "reviews",
    writeReview: "Write a review",
    yourReviewMatters: "Your review matters",
    shareExperience: "Share your experience with DreamNoor...",
    publishReview: "Publish my review",
    sending: "Sending...",
    noReviews: "No reviews yet",
    beFirst: "Be the first to share your experience",

    checkingPayment: "Checking payment...",
    pleaseWait: "Please wait while we verify your payment",
    welcomePremium: "Welcome Premium!",
    premiumSuccess: "You now have access to all DreamNoor features without ads.",
    backToApp: "Back to app",
    sessionExpired: "Session expired",
    paymentError: "Payment error",
    paymentFailed: "Payment could not be confirmed. Please try again.",
    redirecting: "Redirecting...",
    checking: "Checking...",
  },

  es: {
    appName: "DreamNoor",
    welcome: "Bienvenido a",
    salam: "Salam,",
    explore: "Explora tus sueños, comprende tus señales",
    explorer: "Explorar",
    loading: "Cargando...",
    error: "Error",
    retry: "Reintentar",
    back: "Volver",
    send: "Enviar",
    save: "Guardar",
    delete: "Eliminar",
    cancel: "Cancelar",
    close: "Cerrar",
    optional: "opcional",

    navHome: "Inicio",
    navDreams: "Sueños",
    navSigns: "Señales",
    navWellness: "Relax",
    navProfile: "Perfil",
    navJournal: "Diario",

    inspirationTitle: "Inspiración del día",
    dreamsRecorded: "Sueños registrados",
    today: "Hoy",
    interpretDream: "Interpretar un sueño",
    signs: "Señales",
    wellness: "Relax",
    journal: "Diario",
    createAccount: "Crear una cuenta",
    createAccountSub: "Guarda tus sueños y análisis",
    analyzeDreams: "Analizar mis sueños",
    analyzeDreamsSub: "Patrones, emociones, tendencias",

    login: "Iniciar sesión",
    register: "Registrarse",
    name: "Nombre",
    email: "Correo electrónico",
    password: "Contraseña",
    yourName: "Tu nombre",
    yourEmail: "tu@correo.com",
    passwordPlaceholder: "Contraseña",
    loginBtn: "Iniciar sesión",
    registerBtn: "Crear cuenta",
    continueWithout: "Continuar sin cuenta",
    saveYourDreams: "Guarda tus sueños y análisis",
    emailUsed: "Este correo ya está en uso",
    wrongCredentials: "Correo o contraseña incorrectos",
    genericError: "Ocurrió un error",

    interpretTitle: "Interpretar un sueño",
    interpretSub: "La IA analiza tu sueño con sabiduría espiritual",
    personalizeTitle: "Personaliza tu interpretación",
    situationLabel: "Tu situación y sentimientos",
    situationPlaceholder: "Soy un hombre de 30 años, casado, un poco estresado por el trabajo últimamente...",
    describeYourDream: "Tu sueño",
    dreamPlaceholder: "Soñé que caminaba por un jardín luminoso, rodeado de flores blancas...",
    interpretBtn: "Interpretar mi sueño",
    interpreting: "Interpretando...",
    interpretation: "Interpretación",
    interpretError: "Error durante la interpretación. Inténtalo de nuevo.",
    dailyLimitTitle: "Límite alcanzado",
    dailyLimitText: "Has usado tus 3 interpretaciones gratuitas de hoy.",
    dailyLimitCta: "Hazte Premium para interpretaciones ilimitadas",
    remainingToday: "interpretación(es) restante(s) hoy",

    gender: "Sexo",
    male: "Hombre",
    female: "Mujer",
    age: "Edad",
    yourAge: "Tu edad",
    familyStatus: "Estado familiar",
    single: "Soltero/a",
    married: "Casado/a",
    divorced: "Divorciado/a",
    widowed: "Viudo/a",
    childrenCount: "Número de hijos",
    howFeeling: "¿Cómo te sientes?",
    stressed: "Estresado/a",
    calm: "Tranquilo/a",
    tired: "Cansado/a",
    happy: "Feliz",
    anxious: "Ansioso/a",
    sad: "Triste",
    atPeace: "En paz",
    confused: "Confundido/a",
    motivated: "Motivado/a",

    signsTitle: "Comprender las señales",
    signsSub: "Descifra los mensajes de tu vida cotidiana",
    describeSign: "Describe la señal observada",
    signPlaceholder: "Vi un pájaro blanco posarse en mi ventana tres mañanas seguidas...",
    interpretSign: "Interpretar esta señal",
    analyzing: "Analizando...",
    meaning: "Significado",

    dreamJournal: "Diario de sueños",
    dreamCount: "{count} sueño(s) registrado(s)",
    newDream: "Nuevo sueño",
    dreamTitle: "Título del sueño",
    describeDream: "Describe tu sueño en detalle...",
    emotions: "Emociones",
    themes: "Temas",
    saveDream: "Guardar sueño",
    saving: "Guardando...",
    noDreams: "No hay sueños registrados",
    noDreamsSub: "Empieza añadiendo tu primer sueño",
    deleteDream: "¿Eliminar este sueño?",
    interpretThis: "Interpretar este sueño",

    joy: "Alegría", fear: "Miedo", surprise: "Sorpresa", sadness: "Tristeza",
    confusion: "Confusión", peace: "Paz", hope: "Esperanza", anxiety: "Ansiedad",
    water: "Agua", sky: "Cielo", animal: "Animal", person: "Persona",
    light: "Luz", darkness: "Oscuridad", flight: "Vuelo", travel: "Viaje",
    house: "Casa", nature: "Naturaleza", prayer: "Oración", death: "Muerte",

    wellnessTitle: "Relax & Sonidos",
    wellnessSub: "Crea tu ambiente relajante",
    activeSound: "sonido activo",
    activeSounds: "sonidos activos",
    remaining: "restante",
    timer: "Temporizador",
    stopAll: "Detener todo",
    autoStop: "Parar automáticamente después de",
    sea: "Olas del océano",
    seagulls: "Lluvia y pájaros",
    birds: "Pájaros",
    wind: "Viento",
    rain: "Lluvia",
    storm: "Tormenta",
    river: "Río",
    forest: "Bosque",
    fireplace: "Chimenea",
    nightCalm: "Noche tranquila",
    mosque: "Ambiente tranquilo",

    analysisTitle: "Análisis de sueños",
    analysisSub: "Patrones, emociones y tendencias",
    dreamsAnalyzed: "Sueños analizados",
    recurringEmotions: "Emociones recurrentes",
    dominantThemes: "Temas dominantes",
    monthlyActivity: "Actividad mensual",
    startRecording: "Empieza a registrar sueños para ver tus análisis",

    myProfile: "Mi perfil",
    darkMode: "Modo oscuro",
    lightMode: "Modo claro",
    premiumTitle: "DreamNoor Premium",
    premiumMember: "Eres miembro Premium",
    premiumDesc: "Accede a todas las funciones sin anuncios.",
    monthly: "Mensual",
    yearly: "Anual",
    perMonth: "/mes",
    perYear: "/año",
    unlimitedInterpretations: "Interpretaciones ilimitadas",
    noAds: "Sin anuncios",
    fullAccess: "Acceso completo a todas las funciones",
    subscribe: "Suscribirse",
    comingSoon: "Próximamente",
    about: "Acerca de",
    aboutText: "DreamNoor combina la sabiduría islámica tradicional y la inteligencia artificial para ayudarte a explorar tus sueños.",
    logout: "Cerrar sesión",
    language: "Idioma",

    userReviews: "Opiniones de usuarios",
    reviews: "opiniones",
    writeReview: "Escribir opinión",
    yourReviewMatters: "Tu opinión importa",
    shareExperience: "Comparte tu experiencia con DreamNoor...",
    publishReview: "Publicar mi opinión",
    sending: "Enviando...",
    noReviews: "Sin opiniones por el momento",
    beFirst: "Sé el primero en compartir tu experiencia",

    checkingPayment: "Verificando el pago...",
    pleaseWait: "Un momento, estamos verificando tu pago",
    welcomePremium: "¡Bienvenido Premium!",
    premiumSuccess: "Ahora tienes acceso a todas las funciones de DreamNoor sin anuncios.",
    backToApp: "Volver a la aplicación",
    sessionExpired: "Sesión expirada",
    paymentError: "Error de pago",
    paymentFailed: "No se pudo confirmar el pago. Por favor, inténtalo de nuevo.",
    redirecting: "Redirigiendo...",
    checking: "Verificando...",
  },

  ar: {
    appName: "دريم نور",
    welcome: "مرحباً بكم في",
    salam: "السلام عليكم،",
    explore: "اكتشف أحلامك، افهم علاماتك",
    explorer: "استكشف",
    loading: "جارٍ التحميل...",
    error: "خطأ",
    retry: "إعادة المحاولة",
    back: "رجوع",
    send: "إرسال",
    save: "حفظ",
    delete: "حذف",
    cancel: "إلغاء",
    close: "إغلاق",
    optional: "اختياري",

    navHome: "الرئيسية",
    navDreams: "الأحلام",
    navSigns: "العلامات",
    navWellness: "استرخاء",
    navProfile: "حسابي",
    navJournal: "اليوميات",

    inspirationTitle: "إلهام اليوم",
    dreamsRecorded: "أحلام مسجلة",
    today: "اليوم",
    interpretDream: "تفسير حلم",
    signs: "العلامات",
    wellness: "استرخاء",
    journal: "اليوميات",
    createAccount: "إنشاء حساب",
    createAccountSub: "احفظ أحلامك وتحليلاتك",
    analyzeDreams: "تحليل أحلامي",
    analyzeDreamsSub: "أنماط، مشاعر، اتجاهات",

    login: "تسجيل الدخول",
    register: "التسجيل",
    name: "الاسم",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    yourName: "اسمك",
    yourEmail: "بريدك@الإلكتروني.com",
    passwordPlaceholder: "كلمة المرور",
    loginBtn: "تسجيل الدخول",
    registerBtn: "إنشاء حساب",
    continueWithout: "المتابعة بدون حساب",
    saveYourDreams: "احفظ أحلامك وتحليلاتك",
    emailUsed: "هذا البريد الإلكتروني مستخدم بالفعل",
    wrongCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    genericError: "حدث خطأ",

    interpretTitle: "تفسير حلم",
    interpretSub: "الذكاء الاصطناعي يحلل حلمك بحكمة روحانية",
    personalizeTitle: "خصّص تفسيرك",
    situationLabel: "وضعك الحالي ومشاعرك",
    situationPlaceholder: "أنا رجل عمري 30 سنة، متزوج، أشعر ببعض التوتر بسبب العمل...",
    describeYourDream: "حلمك",
    dreamPlaceholder: "حلمت أنني أمشي في حديقة مضيئة، محاط بالزهور البيضاء...",
    interpretBtn: "فسّر حلمي",
    interpreting: "جارٍ التفسير...",
    interpretation: "التفسير",
    interpretError: "خطأ أثناء التفسير. حاول مرة أخرى.",
    dailyLimitTitle: "تم بلوغ الحد",
    dailyLimitText: "لقد استخدمت تفسيراتك الثلاث المجانية لهذا اليوم.",
    dailyLimitCta: "اشترك في بريميوم لتفسيرات غير محدودة",
    remainingToday: "تفسير(ات) متبقية اليوم",

    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    age: "العمر",
    yourAge: "عمرك",
    familyStatus: "الحالة العائلية",
    single: "أعزب/عزباء",
    married: "متزوج/ة",
    divorced: "مطلق/ة",
    widowed: "أرمل/ة",
    childrenCount: "عدد الأطفال",
    howFeeling: "كيف تشعر الآن؟",
    stressed: "متوتر/ة",
    calm: "هادئ/ة",
    tired: "متعب/ة",
    happy: "سعيد/ة",
    anxious: "قلق/ة",
    sad: "حزين/ة",
    atPeace: "مطمئن/ة",
    confused: "مرتبك/ة",
    motivated: "متحمس/ة",

    signsTitle: "فهم العلامات",
    signsSub: "فك رموز رسائل حياتك اليومية",
    describeSign: "صف العلامة التي لاحظتها",
    signPlaceholder: "رأيت طائراً أبيض يحط على نافذتي ثلاثة صباحات متتالية...",
    interpretSign: "تفسير هذه العلامة",
    analyzing: "جارٍ التحليل...",
    meaning: "المعنى",

    dreamJournal: "يوميات الأحلام",
    dreamCount: "{count} حلم/أحلام مسجلة",
    newDream: "حلم جديد",
    dreamTitle: "عنوان الحلم",
    describeDream: "صف حلمك بالتفصيل...",
    emotions: "المشاعر",
    themes: "المواضيع",
    saveDream: "حفظ الحلم",
    saving: "جارٍ الحفظ...",
    noDreams: "لا توجد أحلام مسجلة",
    noDreamsSub: "ابدأ بإضافة حلمك الأول",
    deleteDream: "حذف هذا الحلم؟",
    interpretThis: "تفسير هذا الحلم",

    joy: "فرح", fear: "خوف", surprise: "مفاجأة", sadness: "حزن",
    confusion: "ارتباك", peace: "سلام", hope: "أمل", anxiety: "قلق",
    water: "ماء", sky: "سماء", animal: "حيوان", person: "شخص",
    light: "نور", darkness: "ظلام", flight: "طيران", travel: "سفر",
    house: "بيت", nature: "طبيعة", prayer: "صلاة", death: "موت",

    wellnessTitle: "استرخاء وأصوات",
    wellnessSub: "أنشئ أجواءك المريحة",
    activeSound: "صوت نشط",
    activeSounds: "أصوات نشطة",
    remaining: "متبقي",
    timer: "مؤقت",
    stopAll: "إيقاف الكل",
    autoStop: "إيقاف تلقائي بعد",
    sea: "أمواج المحيط",
    seagulls: "مطر وطيور",
    birds: "الطيور",
    wind: "الرياح",
    rain: "المطر",
    storm: "العاصفة",
    river: "النهر",
    forest: "الغابة",
    fireplace: "المدفأة",
    nightCalm: "ليلة هادئة",
    mosque: "أجواء هادئة",

    analysisTitle: "تحليل الأحلام",
    analysisSub: "أنماط، مشاعر واتجاهات",
    dreamsAnalyzed: "أحلام محللة",
    recurringEmotions: "المشاعر المتكررة",
    dominantThemes: "المواضيع السائدة",
    monthlyActivity: "النشاط الشهري",
    startRecording: "ابدأ بتسجيل الأحلام لرؤية تحليلاتك",

    myProfile: "حسابي",
    darkMode: "الوضع الداكن",
    lightMode: "الوضع الفاتح",
    premiumTitle: "دريم نور بريميوم",
    premiumMember: "أنت عضو بريميوم",
    premiumDesc: "الوصول إلى جميع الميزات بدون إعلانات.",
    monthly: "شهري",
    yearly: "سنوي",
    perMonth: "/شهر",
    perYear: "/سنة",
    unlimitedInterpretations: "تفسيرات غير محدودة",
    noAds: "بدون إعلانات",
    fullAccess: "وصول كامل لجميع الميزات",
    subscribe: "اشترك",
    comingSoon: "قريباً",
    about: "حول التطبيق",
    aboutText: "دريم نور يجمع بين الحكمة الإسلامية التقليدية والذكاء الاصطناعي لمساعدتك على استكشاف أحلامك.",
    logout: "تسجيل الخروج",
    language: "اللغة",

    userReviews: "آراء المستخدمين",
    reviews: "آراء",
    writeReview: "كتابة رأي",
    yourReviewMatters: "رأيك يهمنا",
    shareExperience: "شارك تجربتك مع دريم نور...",
    publishReview: "نشر رأيي",
    sending: "جارٍ الإرسال...",
    noReviews: "لا توجد آراء بعد",
    beFirst: "كن أول من يشارك تجربته",

    checkingPayment: "جارٍ التحقق من الدفع...",
    pleaseWait: "لحظة، نتحقق من دفعتك",
    welcomePremium: "!مرحباً بريميوم",
    premiumSuccess: "لديك الآن حق الوصول إلى جميع ميزات دريم نور بدون إعلانات.",
    backToApp: "العودة إلى التطبيق",
    sessionExpired: "انتهت الجلسة",
    paymentError: "خطأ في الدفع",
    paymentFailed: "لم يتم تأكيد الدفع. يرجى المحاولة مرة أخرى.",
    redirecting: "جارٍ التوجيه...",
    checking: "جارٍ التحقق...",
  },
};

export default translations;
